import React, { useEffect } from 'react'
import { Avatar, FormInstance, Select } from 'antd'
import { useGetLeagueDivisions } from 'api/league/LeagueCreation/leagueDivision'
import Spinner from 'components/Spinner'
import { DivisonListingResp } from 'types/league/division'
import { getNameSignature } from 'helper/utility'
import Chip from 'components/global/Chip'

interface DivisionSelectProps {
  form: FormInstance
  data: string | undefined
  leagueId: string
}

const DivisionSelect: React.FC<DivisionSelectProps> = ({
  form,
  data,
  leagueId,
}) => {
  const {
    isLoading,
    isFetching,
    isError,
    data: leagueDivisionListing,
    refetch,
  } = useGetLeagueDivisions(leagueId)

  useEffect(() => {
    refetch()
  }, [])

  return (
    <div>
      <Select
        className="h-50px select-field"
        placeholder={'Select Division'}
        defaultValue={data}
        optionLabelProp="label"
        onChange={(v, item: { value: string; key: string }) => {
          form.setFieldsValue({
            divisionId: item.value,
          })
        }}
      >
        {isLoading || isFetching ? (
          <div className="py-40px">
            <Spinner />
          </div>
        ) : isError ? (
          <div className="py-40px flex justify-center align-center">
            <p>Something went wrong while loading teams</p>
          </div>
        ) : (
          leagueDivisionListing.map((league: DivisonListingResp) => (
            <Select.Option
              className="border-btm py-15px bg-white"
              key={league._id}
              value={league._id}
              label={league.name}
            >
              <>
                <div className="flex align-center justify-between gap-10px">
                  <div className="flex align-center gap-10px">
                    <div className="w-40px h-40px">
                      <Avatar size={40} src={''}>
                        {getNameSignature(league.name)}
                      </Avatar>
                    </div>
                    <h3 className="text-14 w-500">{league.name}</h3>
                  </div>
                  <p>${league.price?.toFixed(2)}</p>
                </div>
                <div className="flex gap-16px pt-10px">
                  {league.genders?.map((gender, index) => (
                    <Chip key={`gender-${index}`} text={gender} isGray={true} />
                  ))}
                  {league.ageGroups?.map((ageGroup, index) => (
                    <Chip
                      key={`age-${index}`}
                      text={`${ageGroup.name}(${ageGroup.minAge} - ${ageGroup.maxAge} years)`}
                      isGray={true}
                    />
                  ))}
                  {league.skillLevels?.map((skillLevel, index) => (
                    <Chip key={`skill-${index}`} text={skillLevel.name} isGray={true} />
                  ))}
                  {league.regions?.map((region, index) => (
                    <Chip key={`region-${index}`} text={region} isGray={true} />
                  ))}
                </div>
              </>
            </Select.Option>
          ))
        )}
      </Select>
    </div>
  )
}

export default DivisionSelect
